import type {ReactElement} from 'react';
import React, {useState} from 'react';
import type {GridItemProps, GridStockMediaItemBackendData} from '../grid-item';
import type {GridMediaItemStorage} from '../grid-media-item';
import {GridMediaItem} from '../grid-media-item';
import styles from './grid-icon-item.module.scss';

export interface GridIconItemStorage extends GridMediaItemStorage {
  hashedFilename: string;
}

export interface GridIconItemBackEndData extends GridStockMediaItemBackendData {
  idPMWStockIcon: string;
}

interface GridIconItemProps extends GridItemProps {
  thumbSrc: string;
}

export function GridIconItem({...props}: GridIconItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  return (
    <GridMediaItem
      {...props}
      isImageLoaded={isImageLoaded}
      thumb={
        <img
          onLoad={(): void => {
            setIsImageLoaded(true);
          }}
          src={props.thumbSrc}
          className={styles.thumb}
          alt={window.i18next.t('pmwjs_image')}
          draggable="false"
          loading="lazy"
        />
      }
    />
  );
}
